import { Store } from '../../../../helpers';
import { loaded, loading } from '../../../../layout/redux/layoutActions';
import { THeatmapMarkets, THeatmapTypes } from '../types/heatmap.types';
import Map from 'eemovel-map-library/src/data/google-maps/map';
import { toggleHeatmapState } from './heatmap.reducer';
import { isHeatmapAvailable } from '../controllers/heatmap.controller';
import { heatmapLegend } from '../../../../shared/constants';

export const plotHeatmap = async (
  selectedType: THeatmapTypes,
  market: THeatmapMarkets,
  opacity: number
) => {
  if (!isHeatmapAvailable()) return;
  const { heatmap } = Store.getState();
  const data = heatmap[market][selectedType];

  if (!data.length) return;

  Map.removeHeatMap();
  Store.dispatch(loading());
  const heatmapData: google.maps.visualization.HeatmapLayerOptions = {
    data,
    opacity,
    gradient: [...heatmapLegend, 'rgba(0,0,0,0)'].reverse(),
    radius: 40,
  };
  Map.plotHeatMap(heatmapData);
  Store.dispatch(loaded());
  Store.dispatch(toggleHeatmapState(true));
};

export const removeHeatmap = async () => {
  Store.dispatch(loading());
  Map.removeHeatMap();
  Store.dispatch(loaded());
  Store.dispatch(toggleHeatmapState(false));
};
